import { createIcon } from "@chakra-ui/react";

export const TrashCan = createIcon({
  displayName: "TrashCan",
  viewBox: "0 0 24 24",
  d: "M9.224 18.75c0 .413-.33.75-.735.75a.745.745 0 0 1-.735-.75V9c0-.412.331-.75.735-.75.404 0 .735.338.735.75v9.75zm3.673 0c0 .413-.33.75-.734.75a.745.745 0 0 1-.735-.75V9c0-.412.33-.75.735-.75.404 0 .734.338.734.75v9.75zm3.674 0c0 .413-.33.75-.735.75a.745.745 0 0 1-.735-.75V9c0-.412.331-.75.735-.75.404 0 .735.338.735.75v9.75zm-.115-17.58 1.685 2.58h3.205c.611 0 1.102.504 1.102 1.125 0 .623-.49 1.125-1.102 1.125h-.367v14.25c0 2.072-1.644 3.75-3.674 3.75H7.02c-2.029 0-3.674-1.678-3.674-3.75V6H2.98a1.112 1.112 0 0 1-1.102-1.125c0-.621.494-1.125 1.102-1.125h3.206l1.684-2.58A2.56 2.56 0 0 1 10.01 0h4.307a2.56 2.56 0 0 1 2.14 1.17zM8.834 3.75h6.658l-.873-1.333a.367.367 0 0 0-.303-.167H10.01c-.12 0-.275.063-.303.167L8.834 3.75zM5.55 20.25c0 .83.658 1.5 1.47 1.5h10.285c.813 0 1.47-.67 1.47-1.5V6H5.55v14.25z",
  defaultProps: {
    "aria-label": "Remove/Delete icon: A trash can"
  }
});

export default TrashCan;
